<template>
  <div class="md-layout text-center">
    <div class="md-layout-item md-size-33 md-medium-size-50 md-small-size-70 md-xsmall-size-100">
      <login-card style="margin-left:200px;" header-color="primary">
        <h3 slot="title" class="title"><br />Set GlobeChek Password</h3>

        <p slot="subheader" class="subheader">Please create your password</p>

        <md-field slot="inputs" class="md-form-group">
          <md-icon>mail_outline</md-icon>
          <label>Email</label>
          <md-input v-model="username" type="email" />
        </md-field>

        <md-field slot="inputs" class="md-form-group">
          <md-icon>lock_outline</md-icon>
          <label>Password...</label>
          <md-input v-model="psw1" type="password" />
        </md-field>

        <md-field slot="inputs" class="md-form-group">
          <md-icon>lock_outline</md-icon>
          <label>re-enter Password...</label>
          <md-input v-model="psw2" type="password" />
        </md-field>

        <span slot="footer" align="Left">
          <a href="#" style="font-size: .65rem; color: #000000de; margin-left: 30px;">&nbsp;</a>
        </span>

        <md-button slot="footer" class="md-primary" @click="createPsw"> C R E A T E </md-button>

        <span slot="footer" align="Right">
          <a href="#" style="font-size: .65rem; color: #000000de; margin-left: 30px;" @click="goHome">Cancel</a>
        </span>
      </login-card>
    </div>
  </div>
</template>

<script>
import { LoginCard } from "@/components"
import { loadavg } from "os"
export default {
  components: {
    LoginCard
  },
  data() {
    return {
      username: null,
      token: null,
      psw: null,
      psw1: null,
      psw2: null,
      password: null,
      error: false,
      status: null
    }
  },
  mounted() {},
  methods: {
    createPsw() {
      this.clear()
      this.validateMember()
    },

    clear() {
      this.error = null
      this.status = null
      this.token = null
    },
    goHome() {
      this.$router.push("/")
    },

    validateMember() {
      this.psw = null
      let uri1 = window.location.href.split("?")

      if (uri1.length != 2) {
        alert("*** INVALID TOKEN ***")
        this.$router.push("/reset-psw-action?gctoken=994721")
      }
      if (uri1[1] != "gctoken=994721") {
        alert("*** INVALID TOKEN ***")
        this.$router.push("/reset-psw-action?gctoken=994721")
      }
      if (this.psw1.trim() != this.psw2.trim()) {
        alert("*** PASSWORDS DONT MATCH ***")
        this.$router.push("/reset-psw-action?gctoken=994721")
      } else {
        this.psw = this.psw1
      }

      const url = process.env.VUE_APP_URL + "/ismember/" + this.username
      const data = null
      const config = { headers: { "Content-Type": "application/json" } }

      var vm = this
      window.axios
        .get(url, data, config)
        .then(response => {
          console.log(response)
          if (String(response.data).trim() == "true") {
            const url_b = process.env.VUE_APP_URL + "/member/" + this.username
            const config_b = { headers: { "Content-Type": "application/json" } }
            const data_b = {
              psw: this.psw,
              token: this.token
            }

            window.axios
              .put(url_b, data_b, config_b)

              .then(response => {
                alert("*** Your Password has been SET ***")
              })

              .then(response => {
                //POST MESSAGE to Member:
                vm.status = "Sending Message to Member . . . ."
                const config_C = { headers: { "Content-Type": "application/json" } }
                const url_C = process.env.VUE_APP_URL + "/msg/newmessage"
                const data_C = {
                  senderID: "Admin@GlobeChek.com",
                  senderName: "GlobeChek Admin",
                  recipientID: this.username,
                  recipientName: this.username,
                  msg_subject: "PASSWORD CREATED",
                  msg_body: "Your GlobeChek password has successfully been created.<br><br> -  Thank You!",
                  msg_level: "normal"
                }
                window.axios.post(url_C, data_C, config_C)
              })

              .then(response => {
                vm.$router.push("/reading-center")
              })
              .catch(errors => {
                console.log(errors)
                this.status = errors
                alert("ERROR:" + errors)
              })
          } else {
            alert("Sorry, Username not found...")
          }
        })
        .catch(errors => {
          console.log(errors)
          this.status = errors
          //alert(errors);
        })
    }
  }
}
</script>

<style></style>
